export default "__VITE_ASSET__Co6kvQiW__"